import type { MutableRefObject } from 'react';

import {
  ResizeHandles,
  ResizeHandle,
  Panel,
} from '../types/shared-panel-types.js';

/** Get a sorted list of all the resize handles registered for the panels. */
export function getSortedResizeHandles(
  resizeHandles: Record<string, ResizeHandle>,
): ResizeHandles {
  const sortedResizeHandles: ResizeHandles = [];

  for (const [resizeHandleName, resizeHandle] of Object.entries(
    resizeHandles,
  )) {
    sortedResizeHandles.push({ name: resizeHandleName, ...resizeHandle });
  }

  return sortedResizeHandles.sort((a, b) => a.order - b.order);
}

/** Get the resize handle corresponding to the given panel. */
export function getResizeHandle(
  panel: Panel,
  sortedResizeHandles: ResizeHandle[],
): ResizeHandle | null {
  const { order: panelOrder, dismissible } = panel;
  if (dismissible === false) {
    return null;
  }

  const handleIndex = sortedResizeHandles.findIndex(
    (handle) => handle.order === panelOrder,
  );

  return sortedResizeHandles[handleIndex] ?? null;
}

/**
 * Due to panels being rendered conditionally, the handle order does not necessarily match
 * the index in the sorted array. We need the index to get the corresponding panels before and
 * after the resize handle.
 */
export const getActualHandleIndex = (
  sortedResizeHandles: MutableRefObject<ResizeHandles>,
  handleOrder: number,
) => {
  return sortedResizeHandles.current.findIndex(
    (handle) => handle.order === handleOrder,
  );
};
